// ======================================================================
// File Name       : contentDistribution
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const CONTENT_DISTRIBUTION_REGISTER_SERVICE_NAME = 'CONTENT_DISTRIBUTION_SERVICE_NAME';
export const CONTENT_DISTRIBUTION_REGISTER_GET_CONTENT_LIST = 'CONTENT_DISTRIBUTION_REGISTER_GET_CONTENT_LIST';
export const CONTENT_DISTRIBUTION_REGISTER_ADD_CONTENT_LIST = 'CONTENT_DISTRIBUTION_REGISTER_ADD_CONTENT_LIST';
export const CONTENT_DISTRIBUTION_REGISTER_DELETE_CONTENT = 'CONTENT_DISTRIBUTION_REGISTER_DELETE_CONTENT';
export const CONTENT_DISTRIBUTION_REGISTER_CHANGE_DATE = 'CONTENT_DISTRIBUTION_REGISTER_CHANGE_DATE';
export const CONTENT_DISTRIBUTION_REGISTER = 'CONTENT_DISTRIBUTION_REGISTER';
export const CONTENT_DISTRIBUTION_REGISTER_LOCAL_PAGING = 'CONTENT_DISTRIBUTION_LOCAL_PAGING';
export const CONTENT_DISTRIBUTION_REGISTER_LOCAL_SORT = 'CONTENT_DISTRIBUTION_LOCAL_SORT';
export const CONTENT_DISTRIBUTION_REGISTER_RESET = 'CONTENT_DISTRIBUTION_REGISTER_RESET';
export const GET_CONTENT_DISTRIBUTION_OFFER_LIST = 'GET_CONTENT_DISTRIBUTION_OFFER_LIST';
export const CONTENT_DISTRIBUTION_REGISTER_GET_COURSE_LIST = 'CONTENT_DISTRIBUTION_REGISTER_GET_COURSE_LIST';
export const CONTENT_DISTRIBUTION_REGISTER_ADD_COURSE_LIST = 'CONTENT_DISTRIBUTION_REGISTER_ADD_COURSE_LIST';
export const CONTENT_DISTRIBUTION_REGISTER_DELETE_COURSE = 'CONTENT_DISTRIBUTION_REGISTER_DELETE_COURSE';
export const CONTENT_DISTRIBUTION_COURSE_CHANGE_DATE = 'CONTENT_DISTRIBUTION_COURSE_CHANGE_DATE';
export const GET_CONTENT_DISTRIBUTION_COURSE_LIST = 'GET_CONTENT_DISTRIBUTION_COURSE_LIST';
export const CONTENT_DISTRIBUTION_SAVE_SUCCESS = 'CONTENT_DISTRIBUTION_SAVE_SUCCESS';
export const OFFER_LIST_UPDATE_CONTENT_LIST = 'OFFER_LIST_UPDATE_CONTENT_LIST';
export const OFFER_LIST_UPDATE_COURSE_LIST = 'OFFER_LIST_UPDATE_COURSE_LIST';
